import React, { useEffect, useState } from 'react';
import { pesos, numKm, enlaceViaje, nombrePropio } from './formato';
// Hora de Mendoza siempre, aunque el telefono o el navegador esten en otra zona
const TZ = 'America/Argentina/Mendoza';

const API_BASE = 'https://cyker.satelitax.com.ar/api';

const TEAL    = '#74C8D2';
const TEXT1   = '#E6EDF3';
const TEXT2   = '#7D8590';
const SURFACE = '#161B22';
const SURFACE2= '#1C2128';
const BORDER  = '#30363D';
// eslint-disable-next-line no-unused-vars
const GREEN   = '#22C55E';

const CARD = {
  background: SURFACE,
  border: `1px solid ${BORDER}`,
  borderRadius: '16px',
  marginBottom: '12px',
  overflow: 'hidden',
};

function TurnoVigente() {
  const token = new URLSearchParams(window.location.search).get('token');
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!token) {
      setError('Sin token. Cerrá y volvé a abrir desde la app.');
      setLoading(false);
      return;
    }

    const cargar = async () => {
      try {
        const res = await fetch(API_BASE + '/turnos/vigente-completo', {
          headers: { 'Authorization': 'Bearer ' + token }
        });
        if (res.status === 401) { setError('Sesión expirada. Cerrá y volvé a abrir.'); return; }
        if (!res.ok) { setError('Error al cargar turno (' + res.status + ').'); return; }
        setData(await res.json());
      } catch (e) {
        setError('Error de conexión.');
      } finally {
        setLoading(false);
      }
    };

    cargar();
    const interval = setInterval(cargar, 30000);
    return () => clearInterval(interval);
  }, [token]);

  const formatHora = (isoStr) => {
    if (!isoStr) return '-';
    try {
      return new Date(isoStr).toLocaleString('es-AR', {
        day: '2-digit', month: '2-digit',
        hour: '2-digit', minute: '2-digit', timeZone: TZ
      });
    } catch { return isoStr; }
  };

  const formatKm = (metros) => {
    return numKm(metros);
  };

  const fmtDuracion = (isoInicio) => {
    if (!isoInicio) return '--:--';
    const diff = Math.max(0, Math.floor((Date.now() - new Date(isoInicio).getTime()) / 1000));
    const h = Math.floor(diff / 3600), m = Math.floor((diff % 3600) / 60);
    if (h > 0) return `${h}h ${String(m).padStart(2, '0')}m`;
    return `${m}m`;
  };

  const bgStyle = {
    minHeight: '100vh',
    background: '#0D1117',
    padding: '0 16px 40px',
    fontFamily: "'Segoe UI', Roboto, sans-serif",
    position: 'relative',
  };

  const glowStyle = {
    position: 'fixed', top: 0, left: '50%',
    transform: 'translateX(-50%)',
    width: '600px', height: '280px',
    background: 'radial-gradient(ellipse at top, rgba(116,200,210,0.07) 0%, transparent 70%)',
    pointerEvents: 'none', zIndex: 0,
  };

  const contentStyle = { position: 'relative', zIndex: 1, maxWidth: '400px', margin: '0 auto' };

  // --- Loading ---
  if (loading) return (
    <div style={{ ...bgStyle, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
      <div style={glowStyle} />
      <div style={{ position: 'relative', zIndex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <img src="/logo_cyker_web.png" alt="Cyker" style={{ width: '130px', height: 'auto', display: 'block', margin: '0 auto 10px' }} />
        <div style={{
          width: '36px', height: '36px',
          border: `3px solid ${SURFACE2}`, borderTop: `3px solid ${TEAL}`,
          borderRadius: '50%', animation: 'spin 0.8s linear infinite',
        }} />
        <div style={{ color: TEXT2, marginTop: '16px', fontSize: '14px' }}>Cargando turno...</div>
      </div>
      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
    </div>
  );

  // --- Error ---
  if (error) return (
    <div style={{ ...bgStyle, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
      <div style={glowStyle} />
      <div style={{ position: 'relative', zIndex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <img src="/logo_cyker_web.png" alt="Cyker" style={{ width: '130px', height: 'auto', display: 'block', margin: '0 auto 10px' }} />
        <div style={{
          ...CARD, padding: '24px 28px', marginTop: '8px',
          color: TEXT1, fontSize: '15px', textAlign: 'center', maxWidth: '320px',
        }}>
          <div style={{ fontSize: '36px', marginBottom: '12px' }}>⚠️</div>
          <div style={{ fontWeight: '600', marginBottom: '8px' }}>Error</div>
          <div style={{ color: TEXT2, fontSize: '13px' }}>{error}</div>
        </div>
      </div>
    </div>
  );

  const turno = data?.turno;
  const viajes = data?.viajes || [];
  const vehiculo = data?.vehiculo || {};
  const totales = data?.totales || {};

  // --- Sin turno ---
  if (!turno) return (
    <div style={bgStyle}>
      <div style={glowStyle} />
      <div style={contentStyle}>
        <div style={{ textAlign: 'center', paddingTop: '20px', paddingBottom: '24px' }}>
          <img src="/logo_cyker_web.png" alt="Cyker" style={{ width: '130px', height: 'auto', display: 'block', margin: '0 auto 10px' }} />
          <div style={{ fontSize: '10px', color: TEXT2, letterSpacing: '4px', textTransform: 'uppercase' }}>Taxímetro Digital</div>
          {vehiculo.aditamento && (
            <div style={{
              display: 'inline-flex', alignItems: 'center', gap: '8px',
              background: 'rgba(116,200,210,0.1)', border: '1px solid rgba(116,200,210,0.25)',
              borderRadius: '20px', padding: '6px 18px', marginTop: '12px',
            }}>
              <span style={{ fontSize: '18px' }}>🚕</span>
              <span style={{ color: TEAL, fontWeight: '700', fontSize: '16px', letterSpacing: '1px' }}>Taxi {vehiculo.aditamento}</span>
            </div>
          )}
        </div>
        <div style={{ ...CARD, padding: '40px 24px', textAlign: 'center' }}>
          <div style={{ fontSize: '48px', marginBottom: '16px' }}>🅿️</div>
          <div style={{ fontSize: '18px', fontWeight: '700', color: TEXT1, marginBottom: '8px' }}>Sin turno activo</div>
          <div style={{ fontSize: '13px', color: TEXT2 }}>Iniciá un turno desde la app para ver el resumen acá.</div>
        </div>
      </div>
    </div>
  );

  // --- Turno activo ---
  const chofer = nombrePropio((turno.chofer_nombre || '') + ' ' + (turno.chofer_apellido || '')) || '-';

  return (
    <div style={bgStyle}>
      <div style={glowStyle} />
      <div style={contentStyle}>

        {/* Header */}
        <div style={{ textAlign: 'center', paddingTop: '20px', paddingBottom: '24px' }}>
          <img src="/logo_cyker_web.png" alt="Cyker" style={{ width: '130px', height: 'auto', display: 'block', margin: '0 auto 10px' }} />
          <div style={{ fontSize: '10px', color: TEXT2, letterSpacing: '4px', textTransform: 'uppercase' }}>Taxímetro Digital</div>
          {vehiculo.aditamento && (
            <div style={{
              display: 'inline-flex', alignItems: 'center', gap: '8px',
              background: 'rgba(116,200,210,0.1)', border: '1px solid rgba(116,200,210,0.25)',
              borderRadius: '20px', padding: '6px 18px', marginTop: '12px',
            }}>
              <span style={{ fontSize: '18px' }}>🚕</span>
              <span style={{ color: TEAL, fontWeight: '700', fontSize: '16px', letterSpacing: '1px' }}>Taxi {vehiculo.aditamento}</span>
            </div>
          )}
        </div>

        {/* Total recaudado */}
        <div style={CARD}>
          <div style={{ height: '3px', background: TEAL }} />
          <div style={{ padding: '20px 24px', textAlign: 'center' }}>
            <div style={{ fontSize: '11px', color: TEAL, letterSpacing: '2.5px', textTransform: 'uppercase', marginBottom: '6px' }}>
              Total recaudado
            </div>
            <div style={{ fontSize: '58px', fontWeight: '900', color: TEXT1, lineHeight: 1.05, fontVariantNumeric: 'tabular-nums' }}>
              {pesos(totales.importe_total || 0)}
            </div>
            <div style={{
              display: 'inline-flex', alignItems: 'center', gap: '6px', marginTop: '10px',
              background: 'rgba(116,200,210,0.12)', border: '1px solid rgba(116,200,210,0.3)',
              color: TEAL, fontSize: '11px', fontWeight: '700',
              padding: '5px 14px', borderRadius: '12px', letterSpacing: '1px',
            }}>
              <span style={{
                width: '7px', height: '7px', borderRadius: '50%', background: TEAL,
                display: 'inline-block', animation: 'blink 1.5s infinite',
              }} />
              EN CURSO
            </div>
          </div>
        </div>

        {/* Métricas */}
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px', marginBottom: '12px' }}>
          {[
            { label: 'Viajes', value: String(totales.cantidad_viajes || 0) },
            { label: 'Duración', value: fmtDuracion(turno.inicio) },
            { label: 'Km Ocupado', value: formatKm(totales.km_total) },
            // km_totales del turno abierto los manda la app cada 5 min (turnos/progreso); sin dato todavia: guion
            { label: 'Km Libre', value: turno.km_totales == null ? '-'
                : formatKm(Math.max(0, parseFloat(turno.km_totales) * 1000 - (totales.km_total || 0))) },
          ].map(({ label, value }) => (
            <div key={label} style={{
              background: SURFACE, border: `1px solid ${BORDER}`,
              borderRadius: '12px', padding: '14px 8px', textAlign: 'center',
            }}>
              <div style={{ fontSize: '15px', fontWeight: '700', color: TEXT1 }}>{value}</div>
              <div style={{ fontSize: '10px', color: TEAL, textTransform: 'uppercase', letterSpacing: '0.5px', marginTop: '3px' }}>{label}</div>
            </div>
          ))}
        </div>

        {/* Info turno */}
        <div style={{ ...CARD, padding: '16px 20px' }}>
          <div style={{ fontSize: '10px', color: TEAL, fontWeight: '700', letterSpacing: '2px', textTransform: 'uppercase', marginBottom: '12px' }}>
            Información del turno
          </div>
          {[
            { label: 'Chofer', value: chofer },
            { label: 'Inicio', value: formatHora(turno.inicio) },
            { label: 'Patente', value: vehiculo.patente || '-' },
          ].map(({ label, value }, i, arr) => (
            <div key={label} style={{
              display: 'flex', justifyContent: 'space-between', padding: '9px 0',
              borderBottom: i < arr.length - 1 ? `1px solid ${BORDER}` : 'none', fontSize: '14px',
            }}>
              <span style={{ color: TEXT2 }}>{label}</span>
              <span style={{ fontWeight: '600', color: TEXT1 }}>{value}</span>
            </div>
          ))}
        </div>

        {/* Viajes del turno */}
        {viajes.length > 0 && (
          <div>
            <div style={{ fontSize: '10px', color: TEAL, fontWeight: '700', letterSpacing: '2px', textTransform: 'uppercase', marginBottom: '10px', marginTop: '4px' }}>
              Viajes del turno ({viajes.length})
            </div>
            {viajes.map((viaje, idx) => (
              <a key={viaje.id || idx} href={enlaceViaje(viaje)} style={{ ...CARD, padding: '14px 16px', display: 'flex', alignItems: 'center', gap: '14px', textDecoration: 'none', color: 'inherit' }}>
                <div style={{
                  minWidth: '36px', height: '36px', borderRadius: '10px',
                  background: 'rgba(116,200,210,0.1)', border: '1px solid rgba(116,200,210,0.2)',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  fontSize: '13px', fontWeight: '800', color: TEAL,
                }}>
                  #{viajes.length - idx}
                </div>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline' }}>
                    <span style={{ fontSize: '20px', fontWeight: '800', color: TEXT1, fontVariantNumeric: 'tabular-nums' }}>
                      {pesos(parseFloat(viaje.importe) || 0)}
                    </span>
                    <span style={{ fontSize: '12px', color: TEXT2 }}>{formatHora(viaje.inicio)}</span>
                  </div>
                  <div style={{ display: 'flex', gap: '12px', marginTop: '4px', fontSize: '12px', color: TEXT2 }}>
                    <span>{formatKm(viaje.distancia_metros)} km</span>
                    <span>·</span>
                    <span>{viaje.fichas_distancia || 0} fichas dist</span>
                    <span>·</span>
                    <span>{viaje.fichas_espera || 0} fichas esp</span>
                  </div>
                </div>
              <span style={{ color: TEAL, fontSize: '20px', lineHeight: 1 }} aria-hidden="true">›</span>
              </a>
            ))}
          </div>
        )}

        {viajes.length === 0 && (
          <div style={{ ...CARD, padding: '30px 20px', textAlign: 'center' }}>
            <div style={{ fontSize: '32px', marginBottom: '10px' }}>🚖</div>
            <div style={{ fontSize: '14px', color: TEXT2 }}>Sin viajes registrados en este turno todavía.</div>
          </div>
        )}

        <div style={{ textAlign: 'center', marginTop: '8px', color: '#3D444D', fontSize: '11px' }}>
          Turno #{turno.id} · Se actualiza cada 30s
        </div>
      </div>

      <style>{`
        @keyframes blink { 0%,100%{opacity:1} 50%{opacity:0.25} }
        @keyframes spin { to { transform: rotate(360deg); } }
      `}</style>
    </div>
  );
}

export default TurnoVigente;
